import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';

type ContinuosNumberedListsProps = {
  lists: string[];
  startingIndex?: number;
};

const InstructionsNumberedList = ({ lists, startingIndex = 0 }: ContinuosNumberedListsProps) => {
  const calculateNumber = (index: number) => {
    const newValue = index + startingIndex + 1;
    return `${newValue}.`;
  };

  return (
    <List
      sx={{
        padding: 0,
        '& .MuiTypography-root': {
          lineHeight: 1.3,
          fontSize: '14px',
        },
      }}
    >
      {lists.map((text, index) => (
        <ListItem key={index} sx={{ alignItems: 'flex-start', padding: 0 }}>
          <ListItemText primary={calculateNumber(index)} sx={{ mr: 2, width: 2, mb: 0 }} />
          <ListItemText primary={text} sx={{ width: '100%', ml: 1, mb: 0 }} />
        </ListItem>
      ))}
    </List>
  );
};

export default InstructionsNumberedList;
